<template>
  <div id="app">
    <Navbar :slideData="slideData" :screenWidth="screenWidth" @navbarActive="navbarActive" />
    <div>
      <full-page :options="options" id="fullpage" ref="fullpage">
        <div class="section bg-cover" :style="`background-image:url(${bg})`">
            <Home :slideData="slideData" :screenWidth="screenWidth" />
        </div>
        <div class="section bg-cover" :style="`background-image:url(${bg2})`">
            <Products :slideData="slideData" :screenWidth="screenWidth" />
        </div>
        <div class="section bg-cover" :style="`background-image:url(${bg})`">
            <Game :slideData="slideData" :screenWidth="screenWidth" />
        </div>
        <div class="section bg-cover" :style="`background-image:url(${bg2})`">
            <Technology :slideData="slideData" :screenWidth="screenWidth" />
        </div>
        <div class="section bg-cover" :style="`background-image:url(${bg})`">
            <Service :slideData="slideData" :screenWidth="screenWidth" />
        </div>
        <div class="section bg-cover" :style="`background-image:url(${bg2})`">
            <TemplateCase :slideData="slideData" :screenWidth="screenWidth" @openModal="openModal" />
        </div>
        <div v-if="showContact" class="section bg-cover" :style="`background-image:url(${bg})`">
            <Cooperation :slideData="slideData" :screenWidth="screenWidth"  />
        </div>
      </full-page>
    </div>
    <div class="modal fade bd-example-modal-xl" id="myModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog  modal-xl" :class="{'modal-dialog-centered' : screenWidth < 992 }" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ modal.title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img :src="modal.image" style="max-height: 80vh;width: auto;max-width:100%;margin: auto;display: block;">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import background from '@/assets/images/bg1.jpg';
import background2 from '@/assets/images/bg2.jpg';
import Navbar from '@/components/layout/Navbar.vue';
import Home from '@/components/home/Index.vue';
import Products from '@/components/products/Index.vue'
import Game from '@/components/game/Index.vue';
import Technology from '@/components/technology/Index.vue';
import Service from '@/components/service/Index.vue';
import Cooperation from '@/components/cooperation/Index.vue';
import TemplateCase from '@/components/templateCase/Index.vue';
import { mobileTemplates, creditTemplates } from '@/components/templateCase/templates';

const mobileImages = Object.fromEntries(mobileTemplates.map(item => [item.id, item.image]));
const creditImages = Object.fromEntries(creditTemplates.map(item => [item.id, item.image]));
const webImages = {};
for (let i = 1; i <= 20; i++) {
  const key = String(i).padStart(2, '0');
  webImages[key] = require(`@/assets/images/templateCase/web/${key}.jpg`);
}

import { isshowContact } from './utils/query-string';

export default {
  name: 'App',
  components: {
    Navbar,
    Home,
    Products,
    Game,
    Technology,
    Service,
    Cooperation,
    TemplateCase
  },
  data() {
    const showContact = isshowContact();
    const anchors = ['home', 'products', 'game', 'technology', 'service', 'templateCase'];
    const navigationTooltips = ['首页', '极致产品', '游戏中心', '卓越技术', '服务优势', '模版案例'];
    if(showContact){
      navigationTooltips.push('商务合作')
      anchors.push('cooperation')
    }
    return {
      showContact,
      options: {
          afterLoad: this.afterLoad,
          navigation: true,
          verticalCentered: true,
          touchSensitivity:20,
          anchors,
          navigationTooltips,
      },
      slideData: '',
      bg: background,
      bg2: background2,
      screenWidth: document.body.clientWidth,
      modal: {
        title:'',
        image: '',
      }
    }
  },
  methods: {
    checkScreenWidth() {
      if(this.screenWidth < 992) {
      this.options.navigation = false
      }else {
        this.options.navigation = true
      }
    },
    afterLoad(origin, destination) {
      this.slideData = destination.anchor
    },
    navbarActive(data) {
      this.slideData = data
      switch (data) {
        case 'home':
        this.$refs.fullpage.api.moveTo(1)
        break
        case 'products':
        this.$refs.fullpage.api.moveTo(2)
        break
        case 'game':
        this.$refs.fullpage.api.moveTo(3)
        break
        case 'technology':
        this.$refs.fullpage.api.moveTo(4)
        break
        case 'service':
        this.$refs.fullpage.api.moveTo(5)
        break
        case 'templateCase':
        this.$refs.fullpage.api.moveTo(6)
        break
        case 'cooperation':
        this.$refs.fullpage.api.moveTo(7)
        break
      }
    },
    openModal(num) {
      if (num.startsWith('CREDIT-')) {
        this.modal.title = num.replace('CREDIT-', '信用版-')
        this.modal.image = creditImages[num]
      } else if (num.startsWith('V588-')) {
        const webNum = num.replace('V588-', '')
        this.modal.title = num
        this.modal.image = webImages[webNum]
      } else {
        const key = num.replace('DOING-', '')
        this.modal.title = `DOING-${key}`
        this.modal.image = mobileImages[key]
      }
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        this.screenWidth = window.screenWidth
      })()
    }
    this.checkScreenWidth()
  },
  watch: {
    screenWidth(val) {
      if(!this.timer){
        this.screenWidth = val
        if(this.screenWidth < 992) {
          this.options.navigation = false
        }else {
          this.options.navigation = true
        }
        this.timer = true
        let vm = this
        setTimeout(function(){
            vm.timer = false
        },400)
      }
    },
  }
};
</script>

<style lang="scss">
@import "./assets/scss/all.scss";
</style>
